import React from 'react'

import { useWindowSize } from 'msp-integrations'

interface ImageProps {
  src?: string
  alt?: string
  ratio?: '1' | '1/2' | '1/3' | '2/3' | '1/4' | '2/4' | '3/4'
  loading?: 'eager' | 'lazy'
  fetchPriority?: 'auto' | 'high' | 'low'
  innerRef?: any
  className?: string
  forceScale?: boolean
  width?: string
  height?: string
}

const Image = ({
  src,
  alt,
  innerRef,
  className,
  ratio = '1',
  loading = 'lazy',
  fetchPriority = 'auto',
  forceScale = false,
  width,
  height
}: ImageProps) => {
  const { width: currentWidth, breakpoints } = useWindowSize()
  const isMobile = () => currentWidth && currentWidth <= breakpoints.lg

  // @ts-ignore
  const calcWidth = (width: number) => eval(width * eval(ratio))
  const getScaledImg = (src: string, width: string) =>
    src
      .replace(/ /g, '%20')
      .concat(
        `${src.includes('?') ? '&' : '?'}sw=${calcWidth(parseInt(width))}`
      )

  let srcProps: { [index: string]: any } = {}
  srcProps['src'] = src

  if (src && ((ratio === '1' && forceScale) || ratio !== '1')) {
    if (forceScale && isMobile()) ratio = '1/2'
    // @ts-ignore
    srcProps['srcSet'] = Object.values(breakpoints)
      .map((size) => `${getScaledImg(src, size)} ${calcWidth(parseInt(size))}w`)
      .join(', ')
    srcProps['sizes'] = `${calcWidth(100)}vw`
  }

  return (
    <img
      ref={innerRef}
      alt={alt}
      {...srcProps}
      loading={loading}
      fetchpriority={fetchPriority}
      className={className}
      width={width}
      height={height}
    />
  )
}

export default Image
